import config from '../config';
import axiosClient from '../utils/axiosClient';

const getFlashDraw = async() => {
  try {
    const response = await axiosClient.get(
      `${config.API_BASE_URL}/flash-draw`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export {getFlashDraw};
